<template>
  <div>
    <!-- Desktop View - START -->
    <app-layout :title="title">
      <template v-slot:adminnav >
      </template> 
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="mt-3 mb-2">
        <jet-back-link @click="back" class="max-w-7xl "
          >
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
          &nbsp;
          Go back 
          </jet-back-link>

      </div>
      </div>

      <PageTitle :headerTitle="title"> </PageTitle>

      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <p class=" text-xs">View the details of Licence details record.</p>
        <div class="flex justify-between ...">

          <!-- Dropdown start --> 
          <div class="dx-field-value">
            <DxDropDownButton
              :split-button="true"
              :use-select-mode="false"
              :items="alignments"
              :drop-down-options="{ width: 150 }"
              text=" EDIT "
              display-expr="name"
              key-expr="id"
              @button-click="editItem"
              @item-click="onItemClick"
            />
          </div>
          <!-- Dropdown  end -->

<div>
 <span class="bg-blue-500 px-2">
 <i class="fa fa-caret-left text-white" aria-hidden="true"></i> 
</span>
 &nbsp; &nbsp; &nbsp;
 <span class="bg-blue-500 px-2">
   <i class="fa fa-caret-right text-white" aria-hidden="true"></i>
 </span>
 
</div>

</div>

        <div
          id="dataPanel"
          class="bg-white overflow-hidden px-3 shadow-xl my-3 sm:rounded-lg"
        >
          <!-- <div class="col pt-3 px-2">
            <div class="flex justify-between">
              <jet-button
                class="
                  bg-blue-500
                  text-white
                  hover:bg-blue-500 hover:no-underline
                  px-2
                  cursor-pointer
                  text-sm
                "
                @click="back"
                >Back</jet-button
              >

              <div v-if="moduleRoute === 'users'"></div>
              <div v-else-if="moduleRoute === 'audits'"></div>
              <div v-else class="">
                <jet-button
                  @click="editItem"
                  class="
                    btn-suspend
                    px-2
                    hover:no-underline
                    cursor-pointer
                    btn-suspend-container
                    text-sm
                  "
                >
                  Edit
                </jet-button>
                &nbsp;
                <jet-button
                  @click="deleteItem"
                  class="btn-delete px-2 cursor-pointer text-sm"
                >
                  Delete
                </jet-button>
              </div>
              <slot v-if="$slots.action_btn" name="action_btn"></slot>
            </div>
          </div> -->

          <form class="p-2 mt-2">
            <BsShowForm
              :createDef="detailDef"
              :routeDef="moduleRoute"
              :modelData="modelData1"
              :slug="slug"
            >
            </BsShowForm>

            <!-- <input class="mt-2 bg-blue-500 text-xs" type="submit" value="Submit" /> -->
          </form>

          <div class="pt-2">
            <DxTabPanel>
              <DxItem icon="fields" :title="'User'" :key="user">
                <div class="px-2">
                  <RolePanel
                    routeDef="users"
                    :slug="this.slug"
                    :parentRoute="this.moduleRoute"
                    :parentId="this.modelData1.id"
                  >
                  </RolePanel>
                </div>
              </DxItem>


              <DxItem icon="fields" :title="'Permission'" :key="permission">
                <div class="px-2">
                  <RolePanel
                    routeDef="permissions"
                    :slug="this.slug"
                    :parentRoute="this.moduleRoute"
                    :parentId="this.modelData1.id"
                  >
                  </RolePanel>
                </div>
              </DxItem> 



            </DxTabPanel>
          </div>
        </div>

        <DxToast
          v-model:visible="isVisible"
          v-model:message="message"
          v-model:type="type"
        />
      </div>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
/* from Include */
import DetailPanel from "@include/pages/DetailViewPanel.vue";
import BsShowForm from "@include/forms/BsShowForm.vue";
//need to move to include
import Test from "@/components/ProgressBarComponent.vue";
/* from Devextreme */
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";
import { DxToast } from "devextreme-vue/toast";
import { confirm, alert } from "devextreme/ui/dialog";
/* default laravel Jetstream */
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import RolePanel from "@include/pages/AdminRoleDetailPanel.vue";
import BsIndexAdmin from '@/Base/BsIndexAdmin.vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxToolbar from 'devextreme-vue/toolbar';
import JetBackLink from "@/Jetstream/BackLink.vue";

export default {
  props: {
    detailDef: {
      type: Array,
      default: [],
    },
    moduleRoute: String,
    routeDef: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    relationData: {
      type: Object,
      default: () => ({}),
    },
    slug: String,
  },
  components: {
    AppLayout,
    BsShowForm,
    PageTitle,
    DxTabPanel,
    DxItem,
    Test,
    DxDataGrid,
    JetNavLink,
    JetButton,
    DxToast,
    DetailPanel,
    RolePanel,
    BsIndexAdmin,
    DxDropDownButton,
    DxToolbar,
    JetBackLink
  },
  data: function () {
    return {
      alignments : [
          {  name: 'New', action:"create"  },
          {  name: 'Delete', action:"delete" },
        ],
      title: "Role Details",
      modelData1: this.modelData,

      form: this.$inertia.form(),
      isVisible: false,
      message: "",
      type: "success",
      appbarTitle: this.moduleRoute.slice(0, -1),
    };
  },
  created() {},
  methods: {
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },

  
    editItem() {
      // alert(route(this.moduleRoute + ".edit",[this.slug,this.modelData.id]));
      this.form.get(
        route(this.moduleRoute + ".edit", [this.slug, this.modelData.id])
      );
    },
    onItemClick(e) {
      
      if(e.itemData.action == "create")
      {
        this.goToCreate();    
      }
      if(e.itemData.action == "delete")
      {
        this.deleteItem();
      }

    },
    deleteItem() {
      alert("Wait we are working on it!");
    },
    // editItem() {
    //   alert("Wait we are working on it!");
    // },
    back() {
      let backUrl = route(this.moduleRoute, this.slug);
      this.$inertia.get(backUrl);
    },

    hello() {
      alert("hello");
    },
    showLoadPanel() {
      this.loadingVisible = true;
    },
    onShown() {
      setTimeout(() => {
        this.loadingVisible = false;
      }, 3000);
    },
    onHidden() {
      alert("hello qt3.14 ");
    },
  },

  mounted() {},
};
</script>


 <style>
/* This is added because the settings icon was moving up - START */

.manage-margin-in-detail {
  margin-top: 4px;
}

/* This is added because the settings icon was moving up - START */

/*Panel tabs*/
#tab-contents {
  margin: 0 auto;
}

.detail,
.details-tabs-container {
  background-color: var(--white);
  border: 1px solid #ebebeb;
}

.setting-icon-margin-manage {
  margin-top: 0.6px;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}
.nav-panel-heading {
  margin-top: 10px;
}

.detail-heading {
  border-bottom: 1px solid var(--input_grey);
  padding: 2px;
}

.tabs {
  padding: 0;
  display: flex;
  border-bottom: 1px solid var(--input_grey);
  color: var(--text_grey);
}

.detail-tabs {
  margin: 0px 0px 0px 0px !important;
}

.tabs li {
  position: relative;
  background-color: var(--white);
  cursor: pointer;
  font-weight: normal;
  margin: 0px 0px 0px 0px !important;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  list-style-type: none;
}

.tabs li.active {
  border-bottom: 2px solid var(--blue);
  color: #333;
  font-weight: bold;
}

.tabs li::before {
  content: "";
  visibility: hidden;
  width: 0;
  height: 2px;
  border-bottom: 1px solid var(--blue);
  background-color: var(--blue);
}

.tabs li:hover {
  background-color: #c6e3ff;
  color: var(--blue);
  font-weight: bold;
}

.tabs li:hover::before {
  visibility: visible;
  bottom: 0;
  width: 100%;
}

.panel {
  display: none;
  background: var(--white);
  box-shadow: 0 0 0 0 transparent;
  padding: 0 15px;
}

.panel.active {
  display: block;
}

.heading-row-margins {
  margin-left: 13px;
}

.breadcrumb-margin {
  margin-right: -8px;
}

.btn-back {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-top: 1px !important;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}

.btn-suspend {
  background-color: var(--orange) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
}

btn-suspend:hover {
  color: #fff;
  background-color: #5a6268 !important;
}

.btn-up {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  margin-right: 5px;
  padding-bottom: 2px;
}

btn-up:hover {
  color: #000;
}

.btn-delete {
  background-color: var(--red) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 5px;
}

.btn-delete:hover {
  color: #000;
}

.btn-delete-container {
  position: absolute;
  right: 10px;

  margin-top: -25px;
}

.btn-suspend-container {
  position: absolute;
  right: 120px;
}
/* edit dropdown css */
.dx-popup-content > .dx-template-wrapper.custom .dx-field-value{
    width: 82px;
    padding: 5px;
  }

  .dx-dropdownbutton-action.dx-button .dx-button-content {
    padding-left: 12px;
    padding-right: 10px;
    background: #3B82F6;
    color: white;
  }
  

  .color {
    cursor: pointer;
    font-size: 18px;
  }
  .dx-button-mode-contained.dx-buttongroup-item, .dx-button-mode-outlined.dx-buttongroup-item {
  /* padding-left: 3px; */
  padding-right: 3px;
  border-color: #0058ff4f;
}

.br{
  margin-top: 5px !important;
}
</style>

